import { render, staticRenderFns } from "./payments-total.vue?vue&type=template&id=cd41aee0"
import script from "./payments-total.vue?vue&type=script&lang=js"
export * from "./payments-total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports